export default __webpack_public_path__ + "static/media/Lightsaber Obi-Wan ANH - Img - Final2_10.efb8e5b3.jpg";